<script>
	import {
		Dropdown, DropdownToggle, DropdownMenu, DropdownItem,
		ModalBody, ModalFooter, Modal, ModalHeader, Button
	} from '@sveltestrap/sveltestrap';
	import { goto } from '$app/navigation';
	import { DoLogout } from '../services/auth.js';
	import { userObj } from '../stores/authUserStore.js';
	import DcnLogin from '../routes/auth/login/dcn_login.svelte';
	import DcnRegister from '../routes/auth/register/dcn_register.svelte';
	import { base } from '$app/paths';

	let authDialog = $state(null);
	let userName = $derived($userObj?.Username || '');

	function closeModal() {
		authDialog = null;
	}
</script>

{#if userName}
	<Dropdown class="d-inline-block">
		<DropdownToggle
			tag="a"
			color=""
			class="btn header-item waves-effect"
			id="page-header-user-dropdown"
		>
			<span class="d-none d-xl-inline-block ms-1" key="t-henry">{userName}</span>
			<i class="mdi mdi-chevron-down d-xl-inline-block"></i>
		</DropdownToggle>
		<DropdownMenu end>
			<DropdownItem on:click={() => goto(base + '/profile')}>
				<i class="bx bx-user font-size-16 align-middle me-1"></i>
				<span>Profile</span>
			</DropdownItem>
			<DropdownItem href="#">
				<span class="badge bg-success float-end">11</span>
				<i class="bx bx-wrench font-size-16 align-middle me-1"></i>
				<span key="t-settings">Settings</span>
			</DropdownItem>
			<DropdownItem divider />
			<DropdownItem on:click={DoLogout}>
				<i class="bx bx-power-off font-size-16 align-middle me-1 text-danger"></i>
				<span>Logout</span>
			</DropdownItem>
		</DropdownMenu>
	</Dropdown>
{:else}
	<div class="d-inline-flex align-items-center gap-2">
		<Button color="primary" outline on:click={() => authDialog = 'register'}>Register</Button>
		<Button color="primary" on:click={() => authDialog = 'login'}>Please login</Button>
	</div>
{/if}

<Modal isOpen={authDialog !== null} toggle={closeModal} labelledBy="header-auth-dialog-title">
	<ModalHeader toggle={closeModal} id="header-auth-dialog-title">
		{authDialog === 'register' ? 'Register' : 'Login'}
	</ModalHeader>
	<ModalBody>
		{#if authDialog === 'login'}
			<DcnLogin on:loginSuccess={closeModal} onRegister={() => authDialog = 'register'} />
		{:else if authDialog === 'register'}
			<DcnRegister embedded onLogin={() => authDialog = 'login'} onClose={closeModal} />
		{/if}
	</ModalBody>
	<ModalFooter>
		<Button color="secondary" on:click={closeModal}>Cancel</Button>
	</ModalFooter>
</Modal>
